export const fileToBase64 = (blob: Blob): Promise<string | undefined> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      if (typeof reader.result === "string") {
        resolve(reader.result.split(",")[1]); // Extract Base64 part only
      } else {
        reject(new Error("FileReader result is not a string."));
      }
    };

    reader.onerror = () => reject(reader.error);

    reader.readAsDataURL(blob);
  });
};

/**
 * Trigger a browser "Save as" for a Blob.
 *
 * The anchor is attached to the document before the click and the object
 * URL is revoked on a later tick: revoking synchronously after `click()`
 * lets the browser drop the download before it has read the blob, which is
 * how the account invoice downloads silently did nothing (WHO-5450 release).
 */
export const saveBlobAsFile = (blob: Blob, filename: string): void => {
  const url = window.URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.rel = "noopener";
  anchor.style.display = "none";
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  window.setTimeout(() => window.URL.revokeObjectURL(url), 60_000);
};
